import type { AuthorList, Author, Message, ReplyMessage } from "../../types";

// TODO DEFAULT_PERSON
export const getAuthor = (
  authors: AuthorList,
  message: Message | NonNullable<ReplyMessage>
): Author => {
  const { authorId } = message;

  return authors[authorId];
};
